export interface VideoItem {
  id: number;
  title: string;
  category: string;
  thumbnail: string;
  duration: string;
  views: string;
  rating: number;
  updateInfo: string;
  description: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const videos: VideoItem[] = [
  {
    id: 1,
    title: '长风渡',
    category: 'tv-series',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20costume%20drama%20scene%20with%20elegant%20couple%20in%20traditional%20hanfu%20standing%20under%20cherry%20blossom%20tree%2C%20warm%20cinematic%20lighting%2C%20soft%20dreamy%20atmosphere%2C%20film%20grain%20texture%2C%20romantic%20mood%2C%20professional%20cinematography&width=800&height=450&seq=video-thumb-01&orientation=landscape',
    duration: '45:32',
    views: '1286万',
    rating: 9.2,
    updateInfo: '更新至36集',
    description: '布商之女柳玉茹自小遭遇生母病重、庶母不慈、父亲不重视的困境，她不得已谨小慎微，做了十五年模范闺秀。不料，对婚姻抱有憧憬的她却被家里安排嫁给了名满扬州的纨绔顾九思。',
    tags: ['古装', '爱情', '剧情', '热播'],
    isHot: true,
    isNew: false,
  },
  {
    id: 2,
    title: '流浪地球2',
    category: 'movies',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20scene%20with%20futuristic%20space%20station%20and%20Earth%20in%20background%2C%20cinematic%20lighting%20with%20blue%20and%20orange%20tones%2C%20dramatic%20atmosphere%2C%20professional%20film%20photography&width=800&height=450&seq=video-thumb-02&orientation=landscape',
    duration: '173:00',
    views: '3568万',
    rating: 9.5,
    updateInfo: '高清完整版',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。',
    tags: ['科幻', '灾难', '冒险', '高分'],
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    title: '奔跑吧第11季',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Outdoor%20variety%20show%20scene%20with%20group%20of%20celebrities%20running%20and%20laughing%20in%20colorful%20sportswear%2C%20bright%20sunny%20day%2C%20energetic%20atmosphere%2C%20professional%20TV%20production%20quality&width=800&height=450&seq=video-thumb-03&orientation=landscape',
    duration: '92:15',
    views: '2105万',
    rating: 8.8,
    updateInfo: '更新至第8期',
    description: '兄弟团成员再次集结，开启全新一季的欢乐奔跑之旅。本季节目将以全新主题和游戏环节，带领观众感受不一样的综艺体验。',
    tags: ['综艺', '户外', '搞笑', '热门'],
    isHot: true,
    isNew: true,
  },
  {
    id: 4,
    title: '斗罗大陆',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Chinese%203D%20animation%20scene%20with%20young%20warrior%20holding%20magical%20blue%20spirit%20hammer%2C%20fantasy%20landscape%20with%20floating%20islands%2C%20vibrant%20colors%2C%20epic%20atmosphere%2C%20anime%20style&width=800&height=450&seq=video-thumb-04&orientation=landscape',
    duration: '20:15',
    views: '5230万',
    rating: 9.4,
    updateInfo: '更新至263集',
    description: '唐门外门弟子唐三，因偷学内门绝学为唐门所不容，跳崖明志时却来到了另一个世界——斗罗大陆。在这里他遇到了挚爱小舞，与六位伙伴组成史莱克七怪。',
    tags: ['动漫', '玄幻', '热血', '3D'],
    isHot: true,
    isNew: false,
  },
  {
    id: 5,
    title: '狂飙',
    category: 'tv-series',
    thumbnail: 'https://readdy.ai/api/search-image?query=Crime%20drama%20scene%20with%20two%20men%20in%20dark%20suits%20confronting%20each%20other%20in%20dimly%20lit%20room%2C%20intense%20atmosphere%2C%20cinematic%20noir%20lighting%2C%20professional%20film%20photography&width=800&height=450&seq=video-thumb-05&orientation=landscape',
    duration: '45:00',
    views: '4892万',
    rating: 9.7,
    updateInfo: '全39集',
    description: '京海市一线刑警安欣，在与黑恶势力的斗争中，不断遭到保护伞的打击，始终无法将犯罪分子绳之以法。全国政法队伍教育整顿工作开展后，临江省派出指导组入驻京海。',
    tags: ['刑侦', '扫黑', '剧情', '神作'],
    isHot: true,
    isNew: false,
  },
  {
    id: 6,
    title: '满江红',
    category: 'movies',
    thumbnail: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20movie%20scene%20with%20soldiers%20in%20ancient%20armor%20marching%20through%20narrow%20courtyard%20alley%2C%20dark%20dramatic%20lighting%2C%20cinematic%20composition&width=800&height=450&seq=video-thumb-06&orientation=landscape',
    duration: '159:00',
    views: '2980万',
    rating: 8.9,
    updateInfo: '高清完整版',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。一个小兵与亲兵营副统领机缘巧合被裹挟进这巨大阴谋之中。',
    tags: ['历史', '悬疑', '喜剧', '院线'],
    isHot: false,
    isNew: true,
  },
  {
    id: 7,
    title: '向往的生活',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Peaceful%20countryside%20farmhouse%20scene%20with%20celebrities%20cooking%20and%20chatting%20in%20rustic%20kitchen%2C%20warm%20natural%20light%2C%20cozy%20atmosphere%2C%20lifestyle%20TV%20show&width=800&height=450&seq=video-thumb-07&orientation=landscape',
    duration: '88:30',
    views: '1685万',
    rating: 9.0,
    updateInfo: '更新至第12期',
    description: '在远离城市喧嚣的蘑菇屋，一群好友相聚，用劳动换取食材，烹饪美食，分享生活中的点滴感悟。这里是每个人心中向往的生活。',
    tags: ['综艺', '生活', '美食', '慢综艺'],
    isHot: false,
    isNew: false,
  },
  {
    id: 8,
    title: '完美世界',
    category: 'anime',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%203D%20animation%20scene%20with%20young%20hero%20wielding%20golden%20sword%20in%20ancient%20mythical%20world%20with%20giant%20beasts%2C%20vibrant%20celestial%20background%2C%20Chinese%20donghua%20style&width=800&height=450&seq=video-thumb-08&orientation=landscape',
    duration: '22:10',
    views: '3450万',
    rating: 9.1,
    updateInfo: '更新至182集',
    description: '一粒尘可填海，一根草斩尽日月星辰。群雄并起，万族林立，诸圣争霸，乱天动地。一个少年从大荒中走出，一切从这里开始。',
    tags: ['动漫', '玄幻', '热血', '3D'],
    isHot: false,
    isNew: false,
  },
  {
    id: 9,
    title: '地球脉动第三季',
    category: 'documentary',
    thumbnail: 'https://readdy.ai/api/search-image?query=Breathtaking%20nature%20documentary%20scene%20with%20diverse%20wildlife%20in%20savanna%20landscape%2C%20golden%20sunset%20light%2C%20stunning%20aerial%20photography%2C%20BBC%20quality%20production&width=800&height=450&seq=video-thumb-09&orientation=landscape',
    duration: '58:00',
    views: '986万',
    rating: 9.8,
    updateInfo: '全8集',
    description: '从海洋深处到最偏远的丛林，这部纪录片将带领观众踏上令人惊叹的自然之旅，探索地球上最神奇的栖息地和野生动物。',
    tags: ['纪录片', '自然', 'BBC', '4K'],
    isHot: false,
    isNew: true,
  },
  {
    id: 10,
    title: '三体',
    category: 'tv-series',
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20TV%20series%20scene%20with%20mysterious%20countdown%20numbers%20projected%20in%20scientist%20vision%2C%20dark%20ominous%20atmosphere%2C%20professional%20cinematography%20with%20cool%20color%20tones&width=800&height=450&seq=video-thumb-10&orientation=landscape',
    duration: '50:20',
    views: '3568万',
    rating: 9.3,
    updateInfo: '全30集',
    description: '纳米科学家汪淼被警官史强带到联合作战中心，潜入科学边界组织协助调查。在调查过程中，汪淼接触到一个名为ETO的组织，发现三体游戏世界和ETO的秘密。',
    tags: ['科幻', '悬疑', '剧情', '大IP'],
    isHot: true,
    isNew: false,
  },
  {
    id: 11,
    title: '长空之王',
    category: 'movies',
    thumbnail: 'https://readdy.ai/api/search-image?query=Military%20aviation%20movie%20scene%20with%20fighter%20jet%20flying%20through%20clouds%20at%20sunset%2C%20dramatic%20sky%20colors%2C%20cinematic%20action%20sequence%2C%20professional%20film%20photography&width=800&height=450&seq=video-thumb-11&orientation=landscape',
    duration: '127:00',
    views: '1856万',
    rating: 8.7,
    updateInfo: '高清完整版',
    description: '雷宇等优秀飞行员经过严苛选拔正式成为试飞员，在队长张挺的带领下，他们参与到最新型战机的试飞。在不断挑战战机和自我极限的过程中，一个个危机接踵而来。',
    tags: ['军事', '动作', '剧情', '院线'],
    isHot: false,
    isNew: false,
  },
  {
    id: 12,
    title: '王牌对王牌第8季',
    category: 'variety',
    thumbnail: 'https://readdy.ai/api/search-image?query=Studio%20variety%20show%20scene%20with%20celebrities%20playing%20fun%20games%20on%20colorful%20stage%20set%2C%20bright%20stage%20lighting%2C%20entertaining%20atmosphere%2C%20TV%20production&width=800&height=450&seq=video-thumb-12&orientation=landscape',
    duration: '95:40',
    views: '1560万',
    rating: 8.5,
    updateInfo: '更新至第10期',
    description: '经典IP对决，王牌家族与嘉宾们展开激烈而欢乐的游戏比拼。才艺展示、爆笑游戏、温情时刻，每一期都带来不一样的惊喜。',
    tags: ['综艺', '游戏', '搞笑', '热门'],
    isHot: false,
    isNew: true,
  },
];